import { getSessionToken } from "@mittwald/ext-bridge/browser";
import { io, Socket } from "socket.io-client";

/** Sequence numbers are only meaningful within one `streamId`. */
export interface StreamReadyData {
  streamId?: string;
}

interface ServerToClientEvents {
  /** `seq` is missing when talking to a backend that predates the resume support. */
  log: (line: string, seq?: number) => void;
  sshConnected: (data?: StreamReadyData) => void;
  logStreamClosed: () => void;
  error: (message: string) => void;
}

interface ClientToServerEvents {
  subscribe: (data: {
    appInstallationId: string;
    lastSeq: number;
    streamId?: string;
  }) => void;
  unsubscribe: () => void;
}

const url = new URL(
  import.meta.env.VITE_APP_API_BASE_URI,
  window.location.origin,
);

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  url.origin,
  {
    path: `${url.pathname}socket.io`,
    autoConnect: false,
    transports: ["websocket"],
    withCredentials: true,
    // The edge in front of the extension severs long-lived websockets
    // regularly, so reconnect quickly and keep trying.
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 3000,
    auth: (cb) => {
      void getSessionToken().then((sessionToken) => {
        cb({ sessionToken: sessionToken });
      });
    },
  },
);
